import { createSelector } from "reselect";
import { defaultState } from "../../../prescription/state/prescription/state.js";
import { getPrescriptionGlasses, frameSkuProp } from "../../../state/selectors.internal.js";
const getConfiguration = createSelector(
  getPrescriptionGlasses,
  frameSkuProp,
  (pg, frameSku) => pg.configurations[frameSku]
);
const getLensTypeSku = createSelector(getConfiguration, (config) => config?.lensType?.sku);
const getPackageSku = createSelector(getConfiguration, (config) => config?.package);
const getAddOnSku = createSelector(getConfiguration, (config) => config?.addOn);
const getPrescription = createSelector(
  getConfiguration,
  (c) => c?.lensType?.prescriptionInfo ?? defaultState
);
export {
  getAddOnSku,
  getConfiguration,
  getLensTypeSku,
  getPackageSku,
  getPrescription
};
//# sourceMappingURL=selectors.internal.js.map
